
import { Directive, HostListener, Input, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[agencyCoreAppAlphaOnly]',
  standalone: true,
})
export class AppAlphaOnlyDirective {
  @Input() maxLength = 20;
  private regex = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFFa-zA-Z\s]+$/;

  constructor(private el: ElementRef, private control: NgControl) { }
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent): void {
    const key = event.key;
    const current: string = this.el.nativeElement.value;

    if (!this.regex.test(key) || current.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const pastedText: string = event.clipboardData?.getData('text') || '';
    const current: string = this.el.nativeElement.value;

    if (!this.regex.test(pastedText) || (current.length + pastedText.length > this.maxLength)) {
      event.preventDefault();
    }
  }
}
